import { render, staticRenderFns } from "./ApprovalFilters.vue?vue&type=template&id=6518be0e&"
import script from "./ApprovalFilters.vue?vue&type=script&lang=ts&"
export * from "./ApprovalFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports